<template>
  <div id="firmwareUpdate">
    <p class="title">{{ $t('更新日志') }}</p>
    <div class="content animate__animated animate__fadeIn">
      <div class="radioGroup">
        <el-radio-group v-model="updateRadio" size="mini" @input="updateRadioChange">
          <el-radio-button v-wave label="固件">{{$t('固件')}}</el-radio-button>
          <el-radio-button v-wave label="驱动">{{$t('驱动')}}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="main_content">
        <Readme></Readme>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/store/eventBus'
import Readme from '../components/Readme'
export default {
  name: "firmwareUpdate",
  components: {
    Readme
  },
  data() {
    return {
      updateRadio: '固件'
    }
  },
  methods: {
    updateRadioChange() {
      EventBus.$emit('updateRadioChange',this.updateRadio)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #firmwareUpdate {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    padding: 0.1rem;
    //@include background_color('background_color_sidebar');
    @include font_color('font_color');
    .title {
      font-weight: 700;
      font-size: 0.16rem;
    }
    .content {
      display: flex;
      height: 90%;
      width: 100%;
      /deep/.radioGroup {
        margin: 0.3rem 0.2rem;
        .el-radio-group {
          .el-radio-button__inner {
            border-width: 0.01rem;
            border-radius: 0.04rem 0 0 0.04rem;
            padding: 0.07rem 0.15rem;
            font-size: 0.12rem;
          }
        }
        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 0.04rem 0.04rem 0;
        }
      }
      .main_content {
        height: 100%;
        width: 80%;
      }
    }
  }
</style>
